module.exports = __webpack_public_path__ + "img/source.1f39277b.png";